import { orientationsFromConfig } from "../components/config/orientations";
import { saveOrientationShading } from "../components/config/orientationEvidence";
import { prepareSceneInBackground } from "../services/sceneCalculation";

/**
 * "Calculate shading" from outside the layout -- offered before an estimate --
 * on the project as it stands: every face, from its saved layout, and the
 * result stored on that layout as the layout's own calculation would be. A
 * face whose shading did not come back measured keeps what it had.
 */
export async function calculateSavedSceneShading(config, { module, projectId, onProgress, shouldCancel } = {}) {
  const prepared = await prepareSceneInBackground(config, { module, projectId, onProgress, shouldCancel });
  const measured = [prepared?.pv_design, ...(prepared?.orientations || []).slice(1)];
  let next = config;
  orientationsFromConfig(config).forEach((plane, i) => {
    const evidence = measured[i]?.obstacleShading;
    if (evidence?.table && !evidence.stale) next = saveOrientationShading(next, plane.id, evidence);
  });
  return next;
}
